import Client from "./_client";

/**
 * Get topics for CaseMaster problems
 * @returns {Promise} Response data containing topics
 */
export const getCaseMasterTopics = async () => {
  let url = `/casemasterProblem/filter/topics`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get topics. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get CaseMaster problems
 * @param {Object} filters - Filters, pagination (pageNumber, pageSize,
 *  includeTotal) and a `title` substring to search on
 * @returns {Promise} Response data containing the casemasterProblems page
 */
export const getCaseMasterProblems = async (filters) => {
  let url = "/casemasterProblem?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) {
      // Values are encoded because `title` carries whatever the user typed into
      // the search bar; the comma stays literal as the backend splits arrays on it.
      if (Array.isArray(filters[key])) {
        url += `${key}=${filters[key].map(encodeURIComponent).join(',')}&`;
      } else {
        url += `${key}=${encodeURIComponent(filters[key])}&`;
      }
    }
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get case studies. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get CaseMaster preparation list
 * @returns {Promise} Response data containing user's preparation topics
 */
export const getCaseMasterPreparationList = async () => {
  let url = "/casemasterProblem/preparationList";

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get preparation list. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get a specific CaseMaster problem by ID
 * @param {string} problemId - The ID of the case master problem
 * @returns {Promise} Response data containing the problem details
 */
export const getMyCaseMasterContestList = async (batch) => {
  // includeMyAttempts decorates each contest with `totalAttempts` for the
  // logged-in user, which the card needs to tell a used-up mock from a fresh one.
  let url = `/casemasterContest?batch=${batch}&includeMyAttempts=true`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get contest list. Please try again."
    );
  }

  return result?.data?.casemasterContests || [];
};

export const getCaseMasterProblemById = async (problemId) => {
  let url = `/casemasterProblem/${problemId}`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get case study. Please try again."
    );
  }

  return result?.data;
};

